if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

})();

window.onload = () => {;

    console.log('start window on load listener');

    let menu_select = document.querySelectorAll('.selector_section__menuSelector a');

    menu_select = [...menu_select];

    menu_select.forEach(ctaMenu => {
        ctaMenu.addEventListener("click", (e) => {
            e.preventDefault();

            if(!ctaMenu.classList.contains('active')){
                menu_select.forEach(ctaMenu => { ctaMenu.classList.remove('active') });
                ctaMenu.classList.add('active');
            }

            let href_ctaMenu = ctaMenu.getAttribute("href");
            let category_container = document.querySelector(`${href_ctaMenu}`);

            if(category_container){
                if(category_container.classList.contains('hidden')){
                    document.querySelectorAll('ul.categories').forEach(ele => { ele.classList.add('hidden') });
                    document.querySelectorAll('div.content-item').forEach(ele => { ele.classList.add('hidden') });
                    category_container.classList.remove(`hidden`);

                    showMenu(href_ctaMenu);
                }
            }

            function showMenu(href_ctaMenu){
                let categories_cta = document.querySelectorAll(`${href_ctaMenu} li`);
                categories_cta.forEach(ctaCategories => {
                    ctaCategories.addEventListener('click', () => {

                        if(!ctaCategories.classList.contains('active')){
                            document.querySelectorAll(`${href_ctaMenu} li`).forEach(ele => { ele.classList.remove('active') });
                            ctaCategories.classList.add('active');
                        }

                        let categories_link = ctaCategories.getAttribute('data-menu');
                        let content_categories = document.querySelector(`#${categories_link}`);

                        if(content_categories){
                            document.querySelectorAll('div.content-item').forEach(ele => { ele.classList.add('hidden') });

                            content_categories.classList.remove('hidden')
                        }

                    })
                });
            }

        })

    });

    document.querySelector('.selector_section__menuSelector > a').click();
    document.querySelector('.selector_section__CategoriesSelector > ul > li').click();

};